import { yellow } from '@mui/material/colors';

export default theme => ({
    root: {
        width: '100%',
        height: 'auto',
        textAlign: 'left'
    },
    headerContainer: {
        textAlign: 'center',
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(4)
    },
    headerText: {
        fontSize: '18px',
        fontWeight: 'bolder',
        lineHeight: '1.5'
    },
    agreementTitle: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(2),
        fontWeight: 700,
        letterSpacing: '0.02em'
    },
    articleHeading: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(1.5),
        fontWeight: 700
    },
    section: {
        marginTop: theme.spacing(1.5),
        marginBottom: theme.spacing(1.5),
        display: 'block',
        textAlign: 'left'
    },
    clauseRow: {
        display: 'flex',
        alignItems: 'baseline',
        columnGap: theme.spacing(1),
        marginTop: theme.spacing(2.5),
        marginBottom: theme.spacing(1)
    },
    clauseNo: {
        minWidth: '20px',
        fontWeight: 700
    },
    clauseTitle: {
        fontWeight: 600
    },
    subClauseTitle: {
        fontWeight: 600,
        fontSize: '0.95rem'
    },
    clauseText: {
        marginLeft: '20px',
        marginTop: theme.spacing(0.5)
    },
    subsectionNo: {
        minWidth: '20px',
        fontWeight: 700
    },
    areaNames: {
        display: 'flex',
        alignItems: 'flex-start',
        flexDirection: 'column',
        marginTop: theme.spacing(1.5),
        marginBottom: theme.spacing(1.5),
        marginLeft: '20px',
        '& > span': {
            marginBottom: theme.spacing(0.5)
        }
    },
    redColor: {
        color: '#c62828'
    },
    boldOnly: {
        fontWeight: 700
    },
    noticeBlock: {
        marginTop: theme.spacing(1.5),
        marginLeft: '20px'
    },
    addressBlock: {
        marginTop: theme.spacing(1),
        marginLeft: '20px',
        lineHeight: 1.6
    },
    signatureContainer: {
        marginTop: theme.spacing(5)
    },
    signatureBox: {
        border: '1px solid #bdbdbd',
        borderRadius: '6px',
        padding: theme.spacing(2.5),
        maxWidth: '560px',
        backgroundColor: '#fff'
    },
    signatureRow: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(1.5),
        '&:last-child': {
            marginBottom: 0
        }
    },
    signatureLabel: {
        minWidth: '180px',
        fontWeight: 500
    },
    signatureValueLine: {
        flex: 1,
        borderBottom: '1px solid #616161',
        minHeight: '24px',
        display: 'flex',
        alignItems: 'flex-end',
        padding: '0 4px 2px'
    },
    yellowLightBG: {
        background: yellow[300]
    }
});
